import { useInView } from 'react-intersection-observer'

export const useOnScreen = () => {
  const { ref: containerRef, inView: isVisible } = useInView({
    threshold: 0,
  })

  return { containerRef, isVisible }
}
